import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { InfiniteData } from "@tanstack/react-query";

import type { CommentItem, CommentSort } from "@/entities/comment";
import { apiPost, qk } from "@/shared/api";

type Page = { items: CommentItem[]; meta?: unknown };

/**
 * Отметка «Полезно» (доработки §6.1).
 *
 * **Точечная правка кэша, а не оптимистичное обновление.** Оптимизма в
 * приложении нет нигде, и вводить откат ради лайка не окупается: `onMutate` с
 * восстановлением снапшота — это новый класс ошибок в обмен на сотню
 * миллисекунд. Сервер возвращает актуальный счётчик, и он кладётся в кэш
 * ПОСЛЕ подтверждения.
 *
 * **Почему не `invalidateQueries`.** Лента бесконечная: инвалидация
 * перезапрашивала бы все загруженные страницы на каждый тап по сердечку. А
 * поскольку «Полезные» сортируются по этому же счётчику, перезапрос ещё и
 * переставлял бы карточки под пальцем — ровно в тот момент, когда человек в
 * них целится.
 */
export function useVoteHelpful(robotId: number, sort: CommentSort) {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (commentId: number) =>
      apiPost("/api/v1/comments/{comment_id}/helpful", {
        params: { comment_id: commentId },
      }),
    onSuccess: (result, commentId) => {
      client.setQueryData<InfiniteData<Page>>(qk.robotComments(robotId, sort), (previous) => {
        if (!previous) return previous;
        return {
          ...previous,
          pages: previous.pages.map((page) => ({
            ...page,
            items: page.items.map((item) =>
              item.id === commentId
                ? { ...item, helpful_count: result.helpful_count, is_helpful: result.is_helpful }
                : item,
            ),
          })),
        };
      });
    },
  });
}
